import { Controller } from "@hotwired/stimulus"

// Handles dismissible flash messages
export default class extends Controller {
  static values = {
    autoDismiss: Boolean,
    autoDismissDelay: Number
  }

  connect() {
    if (this.hasAutoDismissValue && this.autoDismissValue) {
      this.autoDismissTimeout = setTimeout(() => {
        this.dismiss()
      }, this.hasAutoDismissDelayValue ? this.autoDismissDelayValue : 10000)
    }
  }

  disconnect() {
    if (this.autoDismissTimeout) {
      clearTimeout(this.autoDismissTimeout)
    }
  }

  dismiss() {
    this.element.style.opacity = "0"
    this.element.style.transition = "opacity 0.5s"
    
    setTimeout(() => {
      this.element.remove()
    }, 500)
  }
}